import { AHText, Box, Space, useLayoutContext } from "arkh";
import { FlatList } from "react-native";
import React from "react";

export function OptionSelect<T>(props: {
  unused: T[];
  used: T[];
  renderItem: (item: T) => React.ReactElement;
  usedSectionTitle: string;
  keyExtractor: ((item: T, index: number) => string) | undefined;
  spaceHorizontal?: Space;
}) {
  const layout = useLayoutContext();
  return (
    <Box spaceVertical="large">
      <Box
        spaceHorizontal={props.spaceHorizontal}
        style={{ flexDirection: "row", flexWrap: "wrap" }}
      >
        {props.unused.map(props.renderItem)}
      </Box>
      {props.used.length > 0 && (
        <>
          <Box spaceHorizontal={props.spaceHorizontal ?? "large"}>
            <AHText
              spaceHorizontal={props.spaceHorizontal ?? "large"}
              spaceTop="small"
              spaceBottom="xsmall"
              type="detail"
            >
              {props.usedSectionTitle}
            </AHText>
          </Box>
          <FlatList
            horizontal
            data={props.used}
            contentContainerStyle={{
              paddingHorizontal: layout.space[props.spaceHorizontal ?? "large"],
            }}
            keyExtractor={props.keyExtractor}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item }) => props.renderItem(item)}
          />
        </>
      )}
    </Box>
  );
}
